var _g, _g2, _g3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnmappedStudentsCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1d3faa",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M598.528 537.6h223.631c11.311 0 20.48-9.169 20.48-20.48s-9.169-20.48-20.48-20.48H598.528c-11.311 0-20.48 9.169-20.48 20.48s9.169 20.48 20.48 20.48zM199.649 241.664H423.28c11.311 0 20.48-9.169 20.48-20.48s-9.169-20.48-20.48-20.48H199.649c-11.311 0-20.48 9.169-20.48 20.48s9.169 20.48 20.48 20.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.987 418.816h285.737c16.962 0 30.72 13.758 30.72 30.72v441.006c0 16.962-13.758 30.72-30.72 30.72h-317.44c-16.968 0-30.72-13.754-30.72-30.72v-39.281c0-11.311-9.169-20.48-20.48-20.48s-20.48 9.169-20.48 20.48v39.281c0 39.586 32.089 71.68 71.68 71.68h317.44c39.583 0 71.68-32.097 71.68-71.68V449.536c0-39.583-32.097-71.68-71.68-71.68H593.987c-11.311 0-20.48 9.169-20.48 20.48s9.169 20.48 20.48 20.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.747 709.12h359.086c11.311 0 20.48-9.169 20.48-20.48s-9.169-20.48-20.48-20.48H152.747c-11.311 0-20.48 9.169-20.48 20.48s9.169 20.48 20.48 20.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 749.568H143.36c-16.962 0-30.72-13.758-30.72-30.72V153.6c0-16.962 13.758-30.72 30.72-30.72H460.8c16.962 0 30.72 13.758 30.72 30.72v396.8c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48V153.6c0-39.583-32.097-71.68-71.68-71.68H143.36c-39.583 0-71.68 32.097-71.68 71.68v565.248c0 39.583 32.097 71.68 71.68 71.68H512c11.311 0 20.48-9.169 20.48-20.48s-9.169-20.48-20.48-20.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.571 449.28v106.24c0 16.962-13.758 30.72-30.72 30.72h-229.12v40.96h229.12c39.583 0 71.68-32.097 71.68-71.68V449.28h-40.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.64 702.771v-44.8c0-16.962 13.758-30.72 30.72-30.72h229.12v-40.96H143.36c-39.583 0-71.68 32.097-71.68 71.68v44.8h40.96z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmappedStudentsCount);
export default __webpack_public_path__ + "static/media/unmapped-students-count.3723abf4a22107db1bf00d88e65ef0ee.svg";
export { ForwardRef as ReactComponent };